import Vue from 'vue';
import { createSandbox } from 'vue-kindergarten';
import Router from 'vue-router';
import child from '../child';
import { ROUTES } from '../plugins/types';
import { store } from '../store/store';
import AuthenticatedRouteGoverness from './governesses/authenticatedGoverness';
import RouteGoverness from './governesses/routeGoverness';
import { AnalyticsPerimeter } from './perimeters/analyticsPerimeter';
import { ConfigPerimeter } from './perimeters/configPerimeter';
import { LoginPerimeter } from './perimeters/loginPerimeter';
import { OrdersPerimeter } from './perimeters/ordersPerimeter';
import { PricesPerimeter } from './perimeters/pricesPerimeter';
import { PrintersPerimeter } from './perimeters/printersPerimeter';
import { ProductsPerimeter } from './perimeters/productsPerimeter';
import { PromotionsPerimeter } from './perimeters/promotionsPerimeter';
import { RegistrationPerimeter } from './perimeters/registrationPerimeter';
import { ShopsPerimeter } from './perimeters/shopsPerimeter';
import { TemplatesPerimeter } from './perimeters/templatesPerimeter';
import { UsersPerimeter } from './perimeters/usersPerimeter';
import { WelcomePerimeter } from './perimeters/welcomePerimeter';
//import { StatisticsPerimeter } from './perimeters/statisticsPerimeter';
import { BannersPerimeter } from './perimeters/bannersPerimeter';

const Panel = () => import ('../views/Panel/CphPanel.vue');
const ErrorPage = () => import ('../views/Error/Error.vue');
const NotFoundPage = () => import ('../views/Error/NotFound.vue');
const Printers = () => import ('../views/Panel/Printers/PrintersView.vue');
const Registration = () => import ('../views/Panel/Registration/Registration.vue');

const Shops = () => import ('../views/Panel/Shops/Shops.vue');
const UsersTable = () => import ('../views/Panel/Users/UsersTable.vue');
const UsersShow = () => import ('../components/Panel/Users/UsersShow.vue');
const UserShops = () => import ('../components/Panel/Users/UserShops.vue');
const DeleteShop = () => import ('../components/Panel/Delete.vue');

const Products = () => import ('../components/Panel/Products/Products.vue');
const ShopUsers = () => import ('../views/Panel/Shops/ShopUsers.vue');
const ShowShop = () => import ('../views/Panel/Shops/ShowShop.vue');
const ShopsView = () => import ('../views/Panel/Shops/ShopsView.vue');
const ProductsTable = () => import ('../views/Panel/Products/ProductsTable.vue');
const Welcome = () => import ('../views/Panel/Welcome/WelcomeView.vue');
const Buttons = () => import ('../views/Panel/Registration/Buttons.vue');
const Users = () => import ('../components/Panel/Users/Users.vue');
const ShopsUsers = () => import ('../components/Panel/Shops/ShopsUsers.vue');
//const Products = () => import ('../views/Panel/Products/ProductsView.vue');
const Orders = () => import ('../views/Panel/Orders/OrdersView.vue');

const Analytics = () => import ('../views/Panel/Analytics/AnalyticsView.vue');
const AnalyticsSelect = () => import ('../views/Panel/Analytics/AnalyticsSelect.vue');
const AnalyticsShow = () => import ('../views/Panel/Analytics/AnalyticsShow.vue');
const AnalyticsConversion = () => import ('../views/Panel/Analytics/KibanaConv.vue');

//const Statistics = () => import ('../views/Panel/Statistics/StatisticsView.vue');
const Banners = () => import ('../views/Panel/Banners/BannersView.vue');
//const Welcome = () => import ('../views/Panel/Welcome/WelcomeView.vue');
const Prices = () => import ('../views/Panel/Prices/PricesView.vue');
const Promotions = () => import ('../views/Panel/Promotions/PromotionsView.vue');
const Templates = () => import ('../views/Panel/Templates/TemplatesView.vue');
const Account = () => import ('../views/Panel/Account/AccountView.vue');
const Auth = () => import ('../views/Auth/Auth.vue');
const Login = () => import ('../components/Auth/Login/Login.vue');
const Unauthorized = () => import ('../views/Error/Unauthorized.vue');
const ApiBrowser = () => import ('../views/Panel/ApiBrowser/ApiBrowserView.vue');
const RegisterUser = () => import ('../components/Panel/Registration/User/UserRegistrationForm.vue');
const RegisterShop = () => import ('../components/Panel/Registration/Shops/ShopRegistrationForm.vue');
const Notifications = () => import('../views/Panel/Shops/Notifications.vue');
const Monitoring = () => import('../views/Panel/Shops/Monitoring.vue');
const ProductsBulk = () => import('../views/Panel/Shops/ProductsBulk.vue');
const EnvsBulk = () => import('../views/Panel/Shops/EnvsBulk.vue');
const DefaultRegistration = () => import('../views/Panel/Registration/Default.vue');

const DevicesPage = () => import ('../views/Panel/Devices/Devices.vue');
const DevicesTable = () => import ('../views/Panel/Devices/DevicesTable.vue');

Vue.use(Router);

/**
 * @module Router
 * @description Router definition
 * */
const router = new Router({
    base: '/',
    routes: [
        {
            path: '/error',
            component: Error,
            name: ROUTES.ERROR
        },
        {
            path: '/login',
            //name: 'Auth',
            component: Auth,
            meta: {
                // governess: UnauthenticatedRouteGoverness
            },
            //redirect: {name: 'Login'},
            children: [
                {
                    path: '',
                    name: ROUTES.LOGIN,
                    component: Login,
                    meta: {
                        perimeter: LoginPerimeter,
                        perimeterAction: 'read'
                    }
                }
            ]
        },
        {
            path: '',
            //name: 'Panel',
            component: Panel,
            meta: {
                governess: AuthenticatedRouteGoverness
            },
            children: [
                {
                    path: '/',
                    name: ROUTES.WELCOME,
                    component: Welcome,
                    meta: {
                        perimeter: WelcomePerimeter,
                        perimeterAction: 'read'
                    }
                },
                {
                    path: 'analytics',
                    name: ROUTES.ANALYTICS,
                    component: Analytics,
                    meta: {
                        perimeter: AnalyticsPerimeter,
                        perimeterAction: 'read'
                    },
                    children: [
                        {
                            path: 'select',
                            name: 'Analyticsselect',
                            component: AnalyticsSelect
                        },
                        {
                            path: 'show',
                            name: 'analytics-show',
                            component: AnalyticsShow,
                            props: true
                        },
                        {
                            path: 'conversion',
                            name: 'analytics-conversion',
                            component: AnalyticsConversion
                        }
                    ]
                },
                /*{
                    path: 'statistics',
                    name: ROUTES.STATISTICS,
                    component: Statistics,
                    meta: {
                        perimeter: StatisticsPerimeter,
                        perimeterAction: 'read'
                    }
                },*/
                {
                    path: 'banners',
                    name: ROUTES.BANNERS,
                    component: Banners,
                    meta: {
                        perimeter: BannersPerimeter,
                        perimeterAction: 'read'
                    }
                },
                {
                    path: 'shops',
                    component: Shops,
                    meta: {
                        perimeter: ShopsPerimeter,
                        perimeterAction: 'read'
                    },
                    children:[
                        {
                            path: '',
                            name: ROUTES.SHOPS,
                            component: ShopsView
                        },
                        {
                            path: 'monitoring',
                            component: Monitoring
                        },
                        {
                            path: 'notifications',
                            component: Notifications
                        },
                        {
                            name: 'productsbulk',
                            path: 'productsbulk',
                            component: ProductsBulk
                        },
                        {
                            name: 'envsbulk',
                            path: 'envsbulk',
                            component: EnvsBulk
                        },
                        {
                            name: 'shopsshow',
                            component: ShowShop,
                            path: ':id',
                            props: true
                        },
                        {
                            path:':id/remove',
                            component: DeleteShop
                        },
                        {
                            name: 'shopsedit',
                            path: ':id/edit',
                            component: RegisterShop,
                            props: true
                        },
                        {
                            path: ':id/assignUsers',
                            component: ShopsUsers
                        },
                        {
                            name: 'shopsproducts',
                            path: ':id/products',
                            component: ProductsTable,
                            props: true,
                            children: [
                                {
                                    name: 'FastEdit',
                                    path: ':fastedit',
                                    component: ProductsTable,
                                    props: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'devices',
                    meta: {
                        perimeter: ShopsPerimeter,
                        perimeterAction: 'read'
                    },
                    component: DevicesPage,
                    children:[
                        {
                            path: '',
                            name: ROUTES.DEVICES,
                            component: DevicesTable
                        }
                    ]
                },
                {
                    path: 'printers',
                    name: ROUTES.PRINTERS,
                    component: Printers,
                    meta: {
                        perimeter: PrintersPerimeter,
                        perimeterAction: 'read'
                    }
                },
                /*{
                    path: 'products',
                    name: ROUTES.PRODUCTS,
                    component: Products,
                    meta: {
                        perimeter: ProductsPerimeter,
                        perimeterAction: 'read'
                    }
                },*/
                {
                    path: 'products',
                    component: Products,
                    meta: {
                        perimeter: ProductsPerimeter,
                        perimeterAction: 'read'
                    },
                    children: [
                        {
                            path: '',
                            name: ROUTES.PRODUCTS,
                            component: Products
                        }
                    ]
                },
                {
                    path: 'orders',
                    name: ROUTES.ORDERS,
                    component: Orders,
                    meta: {
                        perimeter: OrdersPerimeter,
                        perimeterAction: 'read'
                    }
                },
                {
                    path: 'users',
                    component: Users,
                    meta: {
                        perimeter: UsersPerimeter,
                        perimeterAction: 'read'
                    },
                    children: [
                        {
                            path: '',
                            name: ROUTES.USERS,
                            component: UsersTable
                        },
                        {
                            path:':id/edit',
                            component: UsersShow
                        },
                        {
                            path:':id/showUsers',
                            component: UsersShow
                        },
                        {
                            path:':id/shops',
                            component: UserShops
                        }
                    ]
                },
                {
                    path: 'registration',
                    component: DefaultRegistration,
                    meta: {
                        perimeter: RegistrationPerimeter,
                        perimeterAction: 'read'
                    },
                    children: [
                        {
                            path: '',
                            name: ROUTES.REGISTRATION,
                            component: Buttons,
                            meta: {
                                perimeter: RegisterUser,
                                perimeterAction: 'read'
                            }
                        },
                        {
                            path: 'old',
                            name: 'old',
                            component: Registration,
                            meta: {
                                perimeter: RegistrationPerimeter,
                                perimeterAction: 'read'
                            }
                        },
                        {
                            path: 'shop',
                            name: ROUTES.REGISTRATION+'shop',
                            component: RegisterShop
                        },
                        {
                            path: 'user',
                            name: ROUTES.REGISTRATION+'user',
                            component: RegisterUser
                        }
                    ]
                },
                {
                    path: 'prices',
                    name: ROUTES.PRICES,
                    component: Prices,
                    meta: {
                        perimeter: PricesPerimeter,
                        perimeterAction: 'read'
                    }
                },
                {
                    path: 'promotions',
                    name: ROUTES.PROMOTIONS,
                    component: Promotions,
                    meta: {
                        perimeter: PromotionsPerimeter,
                        perimeterAction: 'read'
                    }
                },
                {
                    path: 'templates',
                    name: ROUTES.TEMPLATES,
                    component: Templates,
                    meta: {
                        perimeter: TemplatesPerimeter,
                        perimeterAction: 'read'
                    }
                },
                {
                    path: 'account',
                    name: ROUTES.ACCOUNT,
                    component: Account,
                    meta: {
                        perimeter: ConfigPerimeter,
                        perimeterAction: 'read'
                    }
                },
                {
                    path: 'apibrowser',
                    name: ROUTES.API_BROWSER,
                    component: ApiBrowser,
                    meta: {
                        perimeter: ConfigPerimeter,
                        perimeterAction: 'read'
                    }
                },
                {
                    name: '404',
                    path: '/404',
                    component: ErrorPage
                },
                {
                    path: '*',
                    component: NotFoundPage
                }
            ]
        },
        {
            path: '*',
            component: NotFoundPage
        }
    ]
});

/**
 * @methodOf router
 * @method beforeEach
 * @description Before any routing is done, this function is launched to create a sandbox
 * */
router.beforeEach((to, from, next) => {
    store.dispatch('SetActiveShopAction', null);

    function gover (){
        to.matched.forEach(routeRecord => {
            const perimeter = routeRecord.meta.perimeter;
            const Governess = routeRecord.meta.governess || RouteGoverness;
            const action = routeRecord.meta.perimeterAction || 'route';

            if (perimeter) {
                const sandbox = createSandbox(child(store), {
                    governess: new Governess(
                        from,
                        to,
                        next,
                        store
                    ),
                    perimeters: [
                        perimeter
                    ]
                });
                return sandbox.guard(action, { to, from, next, store });
            }
        });
    }

    const testlist = ['Login', 'Welcome'];

    if(testlist.indexOf(to.name) > -1 || !store.state.auth.user.isLoggedin){
        store.dispatch('loginWithToken').then(gover, gover);
    } else {
        gover();
    }

});

export default router;
